import { Outlet, NavLink, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, Inbox, Building2, FileText, LogOut, ExternalLink } from "lucide-react";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/leads", label: "Leads", icon: Inbox },
  { to: "/admin/clinics", label: "Clinics", icon: Building2 },
  { to: "/admin/content", label: "Content", icon: FileText },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = () => { logout(); navigate("/admin/login"); };

  return (
    <div className="min-h-screen bg-secondary/5 flex">
      <aside className="w-60 shrink-0 bg-secondary text-white flex flex-col fixed h-full">
        <div className="p-5 flex items-center gap-2 border-b border-white/10">
          <div className="bg-white rounded-lg p-1.5">
            <img src="/mgd-logo.png" alt="My Global Dentist" className="h-7 w-auto" />
          </div>
        </div>
        <nav className="p-3 space-y-1 flex-1">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={`admin-nav-${l.label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-primary text-white" : "text-white/70 hover:bg-white/10"}`}>
              <l.icon className="w-4 h-4" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10 space-y-1">
          <Link to="/" target="_blank" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-white/70 hover:bg-white/10" data-testid="admin-view-site">
            <ExternalLink className="w-4 h-4" /> View site
          </Link>
          <button onClick={doLogout} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-white/70 hover:bg-white/10" data-testid="admin-logout-btn">
            <LogOut className="w-4 h-4" /> Logout
          </button>
        </div>
      </aside>

      <div className="flex-1 ml-60">
        <header className="h-16 glass border-b border-slate-200 flex items-center justify-between px-8 sticky top-0 z-10">
          <p className="text-sm text-muted-foreground">Welcome back, <b className="text-foreground">{user?.name || "Admin"}</b></p>
          <span className="text-xs text-muted-foreground">{user?.email}</span>
        </header>
        <main className="p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
